// src/components/admin/AdminPanel.js
import React from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import AboutEditor from './AboutEditor';
import ServicesEditor from './ServicesEditor';
import TestimonialsEditor from './TestimonialsEditor';
import HeroEditor from './HeroEditor';
import './AdminPanel.css';

const AdminPanel = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Call the logout handler if provided
    if (onLogout) {
      onLogout();
    }
    
    // Navigate back to the home page
    navigate('/');
  };

  return (
    <div className="admin-container">
      <div className="admin-sidebar">
        <h3>Admin Panel</h3>
        <ul>
          <li><Link to="/admin">Dashboard</Link></li>
          <li><Link to="/admin/hero">Hero Section</Link></li>
          <li><Link to="/admin/about">About Section</Link></li>
          <li><Link to="/admin/services">Services</Link></li>
          <li><Link to="/admin/testimonials">Testimonials</Link></li>
          <li className="logout-item">
            <a href="#" onClick={handleLogout} className="logout-link">
              <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
            </a>
          </li>
        </ul>
      </div>
      
      <div className="admin-content">
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/hero" element={<HeroEditor />} />
          <Route path="/about" element={<AboutEditor />} />
          <Route path="/services" element={<ServicesEditor />} />
          <Route path="/testimonials" element={<TestimonialsEditor />} />
        </Routes>
      </div>
    </div>
  );
};

// Simple dashboard component
const AdminDashboard = () => (
  <div>
    <h2>Website Content Management</h2>
    <p>Welcome to your website admin panel. Select a section from the menu to edit your website content.</p>
    <div className="dashboard-stats">
      <div className="stat-card">
        <h3>5</h3>
        <p>Editable Sections</p>
      </div>
      <div className="stat-card">
        <h3>12</h3>
        <p>Images</p>
      </div>
      <div className="stat-card">
        <h3>3</h3>
        <p>Services</p>
      </div>
    </div>
  </div>
);

export default AdminPanel;